import React from "react";
import { Icon, Tooltip } from "@kdcloudjs/kdesign";
import Grid from "../Grid/Grid";
import "./Axis.less";

function Axis(props) {
  console.log(props);
  const { globalData, model } = props;
  console.log(globalData);
  const { xAxisInfo, yAxisInfo } = globalData || {};

  const generateStyle = (type, index) => {
    if (type === "xAxis") {
      return {
        left:
          xAxisInfo.valueType.type === "grade"
            ? "50%"
            : index !== xAxisInfo.divideScale.values.length - 1
            ? "calc(100% + 10px)"
            : "100%",
      };
    } else {
      return {
        bottom:
          yAxisInfo.valueType.type === "grade"
            ? "50%"
            : index !== 0
            ? "calc(100% + 10px)"
            : "100%",
      };
    }
  };

  return (
    <div className={"axis-container"}>
      <div className="visual-map-axis-main">
        <Grid globalData={globalData} />
        <Icon
          className="up-icon-wrapper"
          type="arrow-up-solid"
          style={{ fontSize: "20px" }}
        />
        <Icon
          className="right-icon-wrapper"
          type="arrow-right-solid"
          style={{ fontSize: "20px" }}
        />
        <div className="y-title">{yAxisInfo?.name}</div>
        <div className="x-title">{xAxisInfo?.name}</div>
        {["percent", "score"].includes(xAxisInfo?.valueType?.type) ||
        ["percent", "score"].includes(yAxisInfo?.valueType?.type) ? (
          <div className="x-y-zero">0</div>
        ) : null}
        <div className="yAxis-wrapper">
          <div
            className={"yAxis-list"}
            style={{
              gridTemplateRows: `repeat(${yAxisInfo.divideScale.values.length}, 1fr)`,
            }}
          >
            {yAxisInfo.divideScale.values
              .reduce((acc, num) => [num, ...acc], [])
              .map((item, index) => (
                <div key={index}>
                  <div style={generateStyle("yAxis", index)}>
                    <Tooltip placement="topRight" tip={item}>
                      <div>{item}</div>
                    </Tooltip>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="xAxis-wrapper">
          <div
            className={"xAxis-list"}
            style={{
              gridTemplateColumns: `repeat(${xAxisInfo.divideScale.values.length}, 1fr)`,
            }}
          >
            {xAxisInfo.divideScale.values.map((item, index) => (
              <div key={index}>
                <div style={generateStyle("xAxis", index)}>
                  <Tooltip tip={item}>
                    <div>{item}</div>
                  </Tooltip>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Axis;
